import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  Badge,
  Card,
  CardBody,
  SimpleGrid,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

function Links() {
  return (
    <Box>
      <HStack spacing={2} mb={4}>
        <Heading size="md" color="gray.800" fontWeight="semibold">
          Useful Links
        </Heading>
        <Badge colorScheme="blue" variant="subtle" fontSize="xs">
          7
        </Badge>
      </HStack>
      
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
        {/* Bridgers Card */}
        <Card 
          bg="white" 
          borderRadius="md" 
          border="1px" 
          borderColor="gray.200"
          _hover={{ 
            borderColor: "blue.300", 
            boxShadow: "md",
            transform: "translateY(-2px)",
            transition: "all 0.2s"
          }}
          cursor="pointer"
          onClick={() => window.open('https://explorer.allchainbridge.com/', '_blank')}
        >
          <CardBody p={6}>
            <VStack spacing={3} align="start">
              <HStack spacing={2}>
                <Box w={3} h={3} bg="blue.500" borderRadius="full" />
                <Text fontWeight="bold" color="gray.900" fontSize="md">
                  Bridgers
                </Text>
              </HStack>
              <Text color="blue.500" fontSize="xs" fontWeight="medium">
                explorer.allchainbridge.com
              </Text>
            </VStack>
          </CardBody>
        </Card>

        {/* Hyperunit Card */}
        <Card 
          bg="white" 
          borderRadius="md" 
          border="1px" 
          borderColor="gray.200"
          _hover={{ 
            borderColor: "green.300", 
            boxShadow: "md",
            transform: "translateY(-2px)",
            transition: "all 0.2s"
          }}
          cursor="pointer"
          as={RouterLink}
          to="/hyperunit"
        >
          <CardBody p={6}>
            <VStack spacing={3} align="start">
              <HStack spacing={2}>
                <Box w={3} h={3} bg="green.500" borderRadius="full" />
                <Text fontWeight="bold" color="gray.900" fontSize="md">
                  Hyperunit
                </Text>
              </HStack>
              <Text color="green.500" fontSize="xs" fontWeight="medium">
                api.hyperunit.xyz
              </Text>
            </VStack>
          </CardBody>
        </Card>

        {/* Impersonator Card */}
        <Card 
          bg="white" 
          borderRadius="md" 
          border="1px" 
          borderColor="gray.200"
          _hover={{ 
            borderColor: "purple.300", 
            boxShadow: "md",
            transform: "translateY(-2px)",
            transition: "all 0.2s"
          }}
          cursor="pointer"
          onClick={() => window.open('http://impersonator.xyz/', '_blank')}
        >
          <CardBody p={6}>
            <VStack spacing={3} align="start">
              <HStack spacing={2}>
                <Box w={3} h={3} bg="purple.500" borderRadius="full" />
                <Text fontWeight="bold" color="gray.900" fontSize="md">
                  Impersonator
                </Text>
              </HStack>
              <Text color="purple.500" fontSize="xs" fontWeight="medium">
                impersonator.xyz
              </Text>
            </VStack>
          </CardBody>
        </Card>

        {/* Wormhole Card */}
        <Card 
          bg="white" 
          borderRadius="md" 
          border="1px" 
          borderColor="gray.200"
          _hover={{ 
            borderColor: "orange.300", 
            boxShadow: "md",
            transform: "translateY(-2px)",
            transition: "all 0.2s"
          }}
          cursor="pointer"
          onClick={() => window.open('https://wormholescan.io/', '_blank')}
        >
          <CardBody p={6}>
            <VStack spacing={3} align="start">
              <HStack spacing={2}>
                <Box w={3} h={3} bg="orange.500" borderRadius="full" />
                <Text fontWeight="bold" color="gray.900" fontSize="md">
                  Wormhole
                </Text>
              </HStack>
              <Text color="orange.500" fontSize="xs" fontWeight="medium">
                wormholescan.io
              </Text>
            </VStack>
          </CardBody>
        </Card>

        {/* Mayan Card */}
        <Card 
          bg="white" 
          borderRadius="md" 
          border="1px" 
          borderColor="gray.200"
          _hover={{ 
            borderColor: "teal.300", 
            boxShadow: "md",
            transform: "translateY(-2px)",
            transition: "all 0.2s"
          }}
          cursor="pointer"
          as={RouterLink}
          to="/mayan"
        >
          <CardBody p={6}>
            <VStack spacing={3} align="start">
              <HStack spacing={2}>
                <Box w={3} h={3} bg="teal.500" borderRadius="full" />
                <Text fontWeight="bold" color="gray.900" fontSize="md">
                  Mayan
                </Text>
              </HStack>
              <Text color="teal.500" fontSize="xs" fontWeight="medium">
                mayan.finance
              </Text>
            </VStack>
          </CardBody>
        </Card>

        {/* DeBridge Card */}
        <Card 
          bg="white" 
          borderRadius="md" 
          border="1px" 
          borderColor="gray.200"
          _hover={{ 
            borderColor: "cyan.300", 
            boxShadow: "md",
            transform: "translateY(-2px)",
            transition: "all 0.2s"
          }}
          cursor="pointer"
          onClick={() => window.open('https://app.debridge.finance/orders', '_blank')}
        >
          <CardBody p={6}>
            <VStack spacing={3} align="start">
              <HStack spacing={2}>
                <Box w={3} h={3} bg="cyan.500" borderRadius="full" />
                <Text fontWeight="bold" color="gray.900" fontSize="md">
                  DeBridge
                </Text>
              </HStack>
              <Text color="cyan.500" fontSize="xs" fontWeight="medium">
                app.debridge.finance
              </Text>
            </VStack>
          </CardBody>
        </Card>

        {/* Chainflip Card */}
        <Card 
          bg="white" 
          borderRadius="md" 
          border="1px" 
          borderColor="gray.200"
          _hover={{ 
            borderColor: "red.300", 
            boxShadow: "md",
            transform: "translateY(-2px)",
            transition: "all 0.2s"
          }}
          cursor="pointer"
          onClick={() => window.open('https://scan.chainflip.io/swaps/all', '_blank')}
        >
          <CardBody p={6}>
            <VStack spacing={3} align="start">
              <HStack spacing={2}>
                <Box w={3} h={3} bg="red.500" borderRadius="full" />
                <Text fontWeight="bold" color="gray.900" fontSize="md">
                  Chainflip
                </Text>
              </HStack>
              <Text color="red.500" fontSize="xs" fontWeight="medium">
                scan.chainflip.io
              </Text>
            </VStack>
          </CardBody>
        </Card>
      </SimpleGrid>
    </Box>
  );
}

export default Links;
